import React from 'react';
import Div from '../Element/Div/Div';
import Flex from '../Flex/Flex';
import Gutter from '../Gutter/Gutter';
import BodyText from '../Typography/BodyText/BodyText';
import DeleteIcon from './DeleteIcon';
import FileIcon from './FileIcon';
import DownloadIcon from './DownloadIcon';
import { CommonProps } from './../Element/Element';
import styles from './File.module.scss';

const isString = (str: any): str is string => typeof str === 'string';
const isFunction = (obj: any): obj is () => void => typeof obj === 'function';
const isValidUrl = (url?: string) => isString(url) && url.indexOf('http') === 0;
const hasError = (message: any) => isString(message) && message.length > 0;

type FileProps = {
  /** Name of the file like example.pdf */
  name: string;
  /** URL for downloading the file */
  url?: string;
  /** State for when we are processing an api call */
  loading?: boolean;
  /** Error message to display on the screen */
  message?: string;
  /** An action which initiates deleting the file */
  onDelete?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
} & CommonProps<'div'>;
// Alias for backwards compatibility
export type FileAttributes = FileProps;

const File: React.FunctionComponent<FileProps> = ({
  name,
  url,
  onDelete,
  loading = false,
  message = '',
}) => {
  const showDelete = !loading && isFunction(onDelete);
  const showDownload = !loading && isValidUrl(url);
  const showError = !loading && hasError(message);

  return (
    <Div className={styles.file} borderRadius={true}>
      <Div
        borderRadius={{ size: 'sm' }}
        backgroundColor="gray100"
        padding={{ horizontal: 'sm', vertical: 'sm' }}
        className={showError ? styles.file_box__error : null}
      >
        <Flex centeredVertically>
          <FileIcon loading={loading} showError={showError} />

          <BodyText tagName="span" padding={{ horizontal: 'xs' }} flexItem>
            {name}
          </BodyText>

          {showDownload && <DownloadIcon url={url} />}

          {showDelete && (
            <React.Fragment>
              <Gutter size="sm" />
              <DeleteIcon onClick={onDelete} />
            </React.Fragment>
          )}
        </Flex>
      </Div>

      <BodyText
        tagName="span"
        size="sm"
        padding={{ horizontal: 'xs', vertical: 'xs' }}
        block
        color="red600"
      >
        {showError ? message : ''}
      </BodyText>
    </Div>
  );
};

export default File;
